export enum TIME_OF_DAY {
	MORNING = 0,
	AFTERNOON = 1,
	EVENING = 2
}
